import { getOrders, getReturn } from "@redotech/redo-customer-portal-app/api";
import { Order } from "@redotech/redo-model/order";
import { Return } from "@redotech/redo-model/return";
import { XOR } from "../xor";

export async function getReturnsUtil(
  returns: Map<string, Set<string>>,
): Promise<Return[]> {
  const newReturnData: Return[] = [];
  const promises: any[] = [];
  returns.forEach((returnIDs) => {
    promises.push(
      ...Array.from(returnIDs).map((returnID) => getReturn(returnID)),
    );
  });
  const responses = await Promise.all(promises);
  responses.forEach((res) => {
    newReturnData.push(res.data);
  });
  return newReturnData;
}

export function getReturnsFromOrders(
  orders: Order[],
): Map<string, Set<string>> {
  const returns: Map<string, Set<string>> = new Map();
  orders.forEach((order) => {
    order.shopify.line_items.forEach((lineItem) => {
      lineItem.returns.forEach((_return: any) => {
        if (!returns.has(order.shopify.order_number)) {
          returns.set(order.shopify.order_number, new Set());
        }
        // @ts-expect-error: strict-null-checks
        returns.get(order.shopify.order_number).add(_return.return_id);
      });
    });
  });
  return returns;
}

export type FetchOrdersUtilParams = XOR<
  { email: string },
  { customerId: string }
>;

export async function fetchOrdersUtil(
  params: FetchOrdersUtilParams,
): Promise<Order[]> {
  let pullNextPage = true;
  let page = 1;
  const orders: any[] = [];

  while (pullNextPage) {
    const { data } = await getOrders({
      ...params,
      getAllStatuses: true,
      page: page,
    });
    if (data === "") {
      break;
    }
    const orderData = data.orders.data;
    orderData.forEach((item: any) => {
      orders.push(item);
    });
    if (page < data.orders.pages) {
      page++;
    } else {
      pullNextPage = false;
    }
  }

  return orders;
}

export async function fetchOrdersPaginated(
  params: FetchOrdersUtilParams,
  page: number,
) {
  const { data } = await getOrders({ ...params, getAllStatuses: true, page });
  return data.orders;
}
